export class TopUpLimit {
    public options: { [options: string]: number | null; } = {};
    public selectedAmount?: number;
    public currency: string | null;
}
